import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(() => {
  return {
    seatIcon: {
      flexShrink: 0
    },
    seatInfoContainer: {
      flexGrow: 1
    }
  };
});
